export const scopes = [
  "orders:get", "orders:update", "orders:create",
  "systems:get", "systems:update",
  "stock:get",
  "products:get", "products:manage", "products:delete", "products:admin",
  "media:get", "media:create",
  "super:admin", "user:admin",
  "products:metadata:get", "products:metadata:create", "products:metadata:update", "products:metadata:delete",
  "estop:update"
]
